// The plugin self-registers its 'gestureHandling' map handler at import time.
// We only need the side-effect import (handler registration) and its CSS.
import 'leaflet-gesture-handling';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';

// react-leaflet's MapContainerProps extends Leaflet's MapOptions, so augmenting
// MapOptions makes the plugin's props typecheck as JSX attributes too.
declare module 'leaflet' {
  interface MapOptions {
    gestureHandling?: boolean;
    gestureHandlingOptions?: {
      text?: { touch?: string; scroll?: string; scrollMac?: string };
      duration?: number;
    };
  }
}

type TFunc = (key: string) => string;

/** Localized overlay text for the gesture-handling hint, shared by all maps. */
export function gestureHandlingText(t: TFunc) {
  return {
    text: {
      touch: t('map.gesture.touch'),
      scroll: t('map.gesture.scroll'),
      scrollMac: t('map.gesture.scrollMac'),
    },
  };
}
